import { useMemo } from 'react';
import MyFlowsIcon from '@honeybook/icons/dist/icons/FolderCheckmark16';
import StarredIcon from '@honeybook/icons/dist/icons/Star16';
import TemplateIcon from '@honeybook/icons/dist/icons/Template16';
import Web16 from '@honeybook/icons/dist/icons/Web16';
import {
    ITemplateMenuItem,
    TemplatePanel
} from '~/components/Templates/types/templates.types';
import { NAMESPACES } from '~/i18n/namespaces';
import { useTranslation } from 'react-i18next';

// This is inside the hook because we sometimes need to run statsig tests to determine whether to show or hide an item.
export const useGetMenuList = () => {
    const { t } = useTranslation(NAMESPACES.TEMPLATES, {
        keyPrefix: 'sidebar'
    });

    const menuList: ITemplateMenuItem[] = useMemo(
        () => [
            {
                section: TemplatePanel.All_flows,
                label: t('all'),
                icon: TemplateIcon,
                analytics: {
                    source: 'all flow templates'
                }
            },
            {
                section: TemplatePanel.Starred,
                label: t('favorites'),
                icon: StarredIcon,
                analytics: {
                    source: 'starred templates'
                }
            },
            {
                section: TemplatePanel.Shared,
                label: t('shared'),
                icon: Web16,
                analytics: {
                    source: 'shared templates'
                }
            },
            {
                section: TemplatePanel.My_flows,
                label: t('saved'),
                icon: MyFlowsIcon,
                analytics: {
                    source: 'my flows'
                }
            }
        ],
        [t]
    );

    return { menuList };
};
